import { FC, memo } from 'react'

import s from './PageTitle.module.scss'

import { Spinner } from 'components/UI/Spinner/Spinner'

interface PageTitleProps {
  title: string | null
  count?: number
  color?: 'secondary' | 'green'
  children?: React.ReactNode | React.ReactNode[]
  className?: string
  testid?: string
  loading?: boolean
}

const PageTitle: FC<PageTitleProps> = memo((props) => {
  const { title, count, color, children, className, testid, loading } = props

  return (
    <div className={`${s.wrapper} ${className ?? ''}`}>
      <h2 data-testid={testid} className={s.titleText}>
        {title}
      </h2>
      <div className={s.afterTitleContentWrapper}>
        {!!count && <span className={`${s.counter} ${color ? s[color] : ''}`}>{count ?? '0'}</span>}
        {children}
        {loading ? (
          <div className={s.loaderWrapper}>
            <Spinner className={s.spinner} />
          </div>
        ) : null}
      </div>
    </div>
  )
})

export default PageTitle
